import { c as _c } from "react/compiler-runtime";
import { Card } from '@/components/ui/card';
import type { HofDashboardDocument } from '@/features/hof-dashboard/api/hof-dashboard-data';
import { DocumentDownloadRow } from '@/features/payload-cms/components/content-blocks/file-download';
import { withLocaleParameter } from '@/features/payload-cms/payload-cms/utils/document-download-name';
import type { Locale } from '@/types/types';
import type React from 'react';

/** Documents to download, as rows of a card the way the website's file download block shows them. */
export const DocumentLinks: React.FC<{
  documents: HofDashboardDocument[];
  locale: Locale;
}> = t0 => {
  const $ = _c(7);
  const {
    documents,
    locale
  } = t0;
  let t1;
  if ($[0] !== documents || $[1] !== locale) {
    let t2;
    if ($[3] !== locale) {
      t2 = document => <DocumentDownloadRow key={document.id} href={withLocaleParameter(document.url, locale)} displayName={document.title} filename={document.filename ?? ""} mimeType={document.mimeType ?? ""} thumbnailUrl={document.pdfThumbnailUrl} filesize={document.filesize} updatedAt={document.updatedAt} openInNewTab={true} locale={locale} />;
      $[3] = locale;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = documents.map(t2);
    $[0] = documents;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <Card as="ul" divided={true}>{t1}</Card>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};